import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { getCommonRoutePath, isGlobalVersionTwo } from '../helpers/Helpers';
const TapPageMain = lazy(() => import(/* webpackChunkName: "home" */ '../containers/Main'));

const RouteAction = ({ testVersion }) => {
    if ((isGlobalVersionTwo && !testVersion) || !isGlobalVersionTwo) {
        return <TapPageMain />;
    } else {
        return <Navigate replace to={getCommonRoutePath() + '/chat-to-us' + window.location.search} />;
    }
};

export default RouteAction;
